import React, { useCallback } from 'react'
import ReactTags, { Tag} from 'react-tag-autocomplete'
import styles from "./TagFormInput.module.scss";
import classNames from 'classnames';
import { useMutation } from '@apollo/client';
import { ADD_TAG, TAG_SUGGESTIONS } from '../../../apollo/queries';
import { client } from '../../../apollo/client';


interface TagInputData {
    tags: Tag[] | []
    setTags: Function
    suggestions: Tag[] | []
}

export const TagFormInput = ({
     tags,
     setTags,
  suggestions
}: TagInputData) => {
    const [addTagAction] = useMutation(ADD_TAG, {
        onCompleted: (data) => {
            const tagsState = tags;
            const index = tagsState.findIndex((obj => obj.name == data.addTag.name));
            tagsState[index].id = data.addTag.id
            setTags(tagsState)
        }
    });

    const addTag = (name: string) => {
        addTagAction({
            variables: {
                name,
            },
        }).then(() => {
            client.refetchQueries({
                include: [TAG_SUGGESTIONS]
            })
        });
    }

    const onDelete = useCallback((tagIndex: number | string) => {
        tags = tags.filter((_, i) => i !== tagIndex)
        setTags(tags)
    }, [tags])

    const onAddition = useCallback((newTag: Tag) => {
        addTag(newTag.name)
        tags = [...tags, newTag]
        setTags(tags)
    }, [tags])

    return (
        <div className={styles.wrapper}>
            <ReactTags
                allowNew={true}
                tags={tags}
                suggestions={suggestions}
                placeholderText={'Add label...'}
                // noSuggestionsText='No matching countries'
                onDelete={onDelete}
                addOnBlur={true}
                onAddition={onAddition}
                // @ts-ignore
                classNames={{
                    root: classNames('react-tags', styles.tagContainer),
                    rootFocused: 'is-focused',
                    selected: 'react-tags__selected',
                    selectedTag: classNames('react-tags__selected-tag', styles.tagWrapper),
                    selectedTagName: 'react-tags__selected-tag-name',
                    search: 'react-tags__search',
                    // searchWrapper: 'react-tags__search-wrapper',
                    searchInput: classNames('react-tags__search-input', styles.tagSearchInput),
                    suggestions: 'react-tags__suggestions',
                    suggestionActive: 'is-active',
                    suggestionDisabled: 'is-disabled',
                    // suggestionPrefix: 'react-tags__suggestion-prefix'
                }}
            />
        </div>
    )
}
